const {h, render, Component} = require('preact');
const StaticButtonView = require('./static_button')
const LiveChatAvailable =  require('./live_chat_available')

class LiveChat extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    this.props.onComponentDidMount()
  }
  populateBCConfig(liveChatSetting)
  {
    window._bcChatWindowUrl = '/customer_support/livechat/web2018theme'
    window._bcForcePopup = liveChatSetting.bcForcePopup
    window._bcSessionApiKey = liveChatSetting.bcSessionApiKey
    window._bcliveChatContainerId = liveChatSetting.liveChatContainerId
    window._bcChatType = liveChatSetting.bcChatType
    window._web2018Chat = true
  }

  render() {
    let contactChannels = this.props.params
    if(contactChannels){
      let liveChatSetting = contactChannels.liveChatSetting
      if(this.props.guestOrder) {
        var guestOrder = this.props.guestOrder
        liveChatSetting.guestQuestion = "\n" + I18n.translate('js.modules.web_2018.order_id_label') + " "+ guestOrder.orderId
        liveChatSetting.userName = 'Guest User';
        liveChatSetting.userEmail = guestOrder.emailId
      }
      return (
        <div id="bc-assets">
            <div id="live-chat-container" class="bcStatic"></div>
            <div id="live-chat"></div>
            <link rel="stylesheet" href={liveChatSetting.boldChatAssetUrl}/>
            <div class="bc-busy-img gig-spinner gig-spinner-prim t-loading-indicator" style="display:none"/>
            <script type="text/javascript">
              {this.populateBCConfig(liveChatSetting)}
            </script>
            <script src={liveChatSetting.boldchatInitializer} type="text/javascript"></script>
            <StaticButtonView liveChatSetting={liveChatSetting}/>
            <script src={liveChatSetting.boldchatScript} type="text/javascript"></script>
        </div>
      )
    }
  }
}

module.exports = LiveChat
